<template>
  <h1 class="text-3xl font-bold tracking-tight text-zinc-800 sm:text-4xl dark:text-zinc-100">
    {{ props.text }}
  </h1>
</template>

<script setup lang="ts">
const props = defineProps<{ text: string }>()
</script>
